import moment from 'moment';

export function localScheduleDate(scheduledDate) {
    if (!scheduledDate && scheduledDate !== 0) return '';
    return moment.unix(scheduledDate).format('DD-MM-YYYY');
}

export function localScheduleDay(scheduledDate) {
    if (!scheduledDate && scheduledDate !== 0) return '';
    return moment.unix(scheduledDate).format('dddd');
}
